import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { dateformat } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';
import { SessionUnfreezeConfirmationComponent } from '../session-unfreeze-confirmation/session-unfreeze-confirmation.component';
import { UnFreezeSessionDialogConstants } from 'src/app/constants/LabelConstants';

@Component({
    selector: 'app-un-freeze-session-dialog',
    templateUrl: './un-freeze-session-dialog.component.html',
    styleUrls: ['./un-freeze-session-dialog.component.scss'],
    standalone: false
})

export class UnFreezeSessionDialogComponent {
  public hostCtrl: FormControl = new FormControl();
  protected filteredhost: ReplaySubject<any> = new ReplaySubject();
  dataSource = new MatTableDataSource<any>([]);
  protected _onDestroy = new Subject();
  sessionList: any[] = [];
  hostList: any = [];
  protected allHostlist: any[] = this.hostList;
  selectedHostData: any = null;
  selectedHostId: any = [];
  dateFormat: any;
  showData: boolean = false;
  labelConstants: any;
  minStartDate: Date = new Date();
  minStartTime: any;
  minEndDate: Date = new Date();
  minEndTime: any;
  unfreezeForm: FormGroup;
  submitted: boolean = false;

  displayedColumns: string[] = [
    'HostedBy',
    'ClassName',
    'Date',
    'Time',
    'Participants',
  ];

  constructor(
    private dialogRef: MatDialogRef<UnFreezeSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe) {
    this.unfreezeForm = this.formBuilder.group({
      host: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      startTime: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      endTime: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.filteredhost.next(this.allHostlist.slice());
    this.dateFormat = dateformat;
    this.minStartTime = null;
    this.minEndTime = null;
    this.labelConstants = UnFreezeSessionDialogConstants;
    this.hostCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filterHost();
    });
    this.fetchHostList();
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  getInstructorNameById(id: number): string {
    const instructor = this.allHostlist.find(customer => customer.userId === id);
    return instructor ? instructor.fullName : '';
  }

  get selectedInstructorNames(): string {
    if(this.selectedHostId.length > 0 ){

      return this.selectedHostId
      .map(id => this.getInstructorNameById(id))
      .join(', ');
    }
    else {
      return '';
    }
  }

  startDateChange() {
    this.unfreezeForm.patchValue({
      startTime: null
    });
    if (this.unfreezeForm.value.startDate > this.unfreezeForm.value.endDate) {
      this.unfreezeForm.patchValue({
        endDate: null
      });
    }
    this.minEndDate = this.unfreezeForm.value.startDate;
    this.minEndTime = this.unfreezeForm.value.startTime;

    if (this.datePipe.transform(this.unfreezeForm.value.startDate, 'dd/MM/yyyy') == this.datePipe.transform(new Date(), 'dd/MM/yyyy')) {
      this.minStartTime = this.datePipe.transform(new Date(), 'hh:mm a');
    }
    else {
      this.minStartTime = null;
    }
    this.sessionList = [];
  }

  endDateChange() {
    this.unfreezeForm.patchValue({
      endTime: null
    });

    if (this.datePipe.transform(this.unfreezeForm.value.endDate, 'dd/MM/yyyy') == this.datePipe.transform(new Date(), 'dd/MM/yyyy')) {
      this.minEndTime = this.datePipe.transform(new Date(), 'hh:mm a');
    }
    else {
      this.minEndTime = null;
    }
    this.sessionList = [];
  }

  fetchHostList() {
    let api = this.api.apiUrl.Class.GetHostList.replace('{listType}', "false");
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.allHostlist = response.data;
          this.filteredhost.next(this.allHostlist.slice());
        }
        else {
          this.spinner.hide();
          this.toastr.error(response.message);
        }
      }, error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  protected filterHost() {
    if (!this.allHostlist) {
      return;
    }
    let search = this.hostCtrl.value;
    if (!search) {
      this.filteredhost.next(this.allHostlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredhost.next(
      this.allHostlist.filter(
        (data) => data.fullName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  customerDropdownImageHandler(customer: any) {
    customer.hostImageUrl = '../../../assets/img/default-customer-profile.svg';
  }

  cancel() {
    this.dialogRef.close();
  }

  formatDate(dateString: string, timeString: string): string {
    const date = new Date(dateString);

    const timeParts = timeString.split(":");
    let hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1].split(" ")[0]);
    const meridian = timeParts[1].split(" ")[1];

    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }

    date.setHours(hours, minutes);
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    return localDate.toISOString();
  }

  search() {
    this.submitted = true;
    let api = this.api.apiUrl.Class.GetFreezeUnFreeseSessionList;
    if (!this.unfreezeForm.valid) {
      return;
    }

    let obj = {
      HostIds: this.unfreezeForm.value.host ? this.unfreezeForm.value.host.join(",") : "",
      SessionStartDateTime: this.unfreezeForm.value.startDate ? this.formatDate(this.unfreezeForm.value.startDate, this.unfreezeForm.value.startTime) : null,
      SessionEndDateTime: this.unfreezeForm.value.endDate ? this.formatDate(this.unfreezeForm.value.endDate, this.unfreezeForm.value.endTime) : null,
      SessionFilter: true
    };
    this.spinner.show();
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.sessionList = response.data;
          this.dataSource = response.data;
          if (response.data.length <= 0) {
            this.toastr.error("No session record found for selected date and instructor(s).")
          }
        }
        this.spinner.hide();
      }, error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  unfreezeSession() {
    const dialogRef = this.dialog.open(SessionUnfreezeConfirmationComponent, {
      width: '460px',
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let api = this.api.apiUrl.Class.UnfreezeSession;
        const userIds = Array.from(
          new Set(this.sessionList.map(session => session.userId))
        ).join(',');
        let obj = {
          HostedById: userIds ? userIds : "",
          StartDate: this.formatDate(this.unfreezeForm.value.startDate, this.unfreezeForm.value.startTime),
          EndDate: this.formatDate(this.unfreezeForm.value.endDate, this.unfreezeForm.value.endTime),
          OffSet: this.commonService.getTimeZone()
        };
        this.spinner.show();
        this.commonService.doPost(api, obj).pipe().subscribe({
          next: (response) => {
            if (response.success) {
              this.toastr.success("Sessions unfreezed successfully.")
            }
            this.spinner.hide();
            this.dialogRef.close();
          }, error: (err) => {
            this.spinner.hide();
            console.log(err);
          }
        });
      }
    });
  }
  
  onInstructorChange(event: any) {
    this.sessionList = [];
  }

  onStartTimeChange(event: any){
    this.sessionList = [];
  }

  onEndTimeChange(event: any){
    this.sessionList = [];
  }
}
